import * as React from 'react';

import { useHiddenMessagePhones } from './useHiddenMessagePhones';

export const useMessageText = ({
  text,
  isOutcoming,
  hiddenMessagePhonesClick,
  userId,
}: {
  text: string;
  isOutcoming: boolean;
  hiddenMessagePhonesClick: () => void;
  userId: number;
}) => {
  const { replacePhoneNumbers } = useHiddenMessagePhones({
    messageUserId: userId,
    isOutcoming,
    onClick: hiddenMessagePhonesClick,
  });

  return React.useMemo(() => {
    if (!text) {
      return null;
    }

    const trimmedText = text.trim();

    if (!trimmedText) {
      return null;
    }

    return trimmedText.split('\n').map((item, key) => (
      <span key={`text-${key}`}>
        {replacePhoneNumbers(item)}
        <br />
      </span>
    ));
  }, [replacePhoneNumbers, text]);
};
